import accessgroupService from "@/services/access-group.service.js";

const state = {
    access_groups: []
}

const mutations = {
    SET_ACCESS_GROUPS(state, data){
        state.access_groups = data;
    }
}

const actions = {
    async fetchAccessGroups({ commit }){
        try {
            let response = await accessgroupService.getAll();
            commit('SET_ACCESS_GROUPS', response.data);
        } 
        catch (error) {
            console.log(error.response ? error.response.status : error);
        }
    }
}

const getters = {
    getAccessGroups: (state) =>{
        return state.access_groups;
    },
    getDefaultAccessGroup(state) {
        return state.access_groups.find(a => a.title == 'Övriga');
    }
}

export default {
    state,
    mutations,
    actions,
    getters
}